import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import compassLogo from '../assets/surthrivaling_compass_logo.png';
import { navigateToSection } from '../utils/navigateToSection';

const NAV_ITEMS = [
  { label: 'Notes', id: 'notes' },
  { label: 'Videos', id: 'videos' },
  { label: 'About', id: 'about' },
  { label: 'Contact', id: 'contact' },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  useEffect(() => {
    if (pathname === '/' && hash) {
      const sectionId = hash.replace('#', '');
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [pathname, hash]);

  const handleLogoClick = (event) => {
    event.preventDefault();
    setMenuOpen(false);

    if (pathname === '/') {
      if (hash) {
        navigate('/', { replace: true });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    navigate('/', { state: { scrollToTop: true } });
  };

  const handleSectionNav = (item) => {
    setMenuOpen(false);
    navigateToSection(navigate, pathname, item.id);
  };

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link
          to="/"
          className="navbar__logo-btn"
          aria-label="Surthrivaling home"
          onClick={handleLogoClick}
        >
          <img src={compassLogo} alt="" className="navbar__logo" />
        </Link>

        <nav className="navbar__desktop" aria-label="Main navigation">
          <ul className="navbar__links">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="navbar__link"
                  onClick={() => handleSectionNav(item)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <button
          type="button"
          className={`navbar__toggle ${menuOpen ? 'is-open' : ''}`}
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div
        id="mobile-menu"
        className={`navbar__mobile ${menuOpen ? 'is-open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <nav aria-label="Mobile navigation">
          <ul className="navbar__mobile-links">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="navbar__mobile-link"
                  onClick={() => handleSectionNav(item)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
